import { render, staticRenderFns } from "./portlet.vue?vue&type=template&id=0df540e0"
import script from "./portlet.ts?vue&type=script&lang=js&external"
export * from "./portlet.ts?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\TafStore.PharmUP.Client\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0df540e0')) {
      api.createRecord('0df540e0', component.options)
    } else {
      api.reload('0df540e0', component.options)
    }
    module.hot.accept("./portlet.vue?vue&type=template&id=0df540e0", function () {
      api.rerender('0df540e0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/child/containers/portlet.vue"
export default component.exports